export const bookingStatus = {
	pending: "pending",
	cancelled: "cancelled",
	done: "done",
};
